// hooks
import { useLocation } from "react-router";
// components
import Iconify from "../../../components/Iconify";
import HomeIcon from "@mui/icons-material/Home";

// ------------------------------------------------------------------------------------------------

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const NavConfig = () => {
  const query = useQuery();
  const reviewProgram = query.get("review-program");

  return [
    {
      subheader: "Overview",
      items: [{ title: "Home", path: "/welcome/home", icon: <HomeIcon /> }],
    },
    {
      subheader: "Program",
      items: [
        {
          title: "Meals",
          path: `/overview/meals`,
          icon: <Iconify icon="game-icons:hot-meal" />,
        },
        {
          title: "Supplements",
          path: "/overview/supplements",
          icon: <Iconify icon="icon-park-solid:medicine-bottle-one" />,
        },
        {
          title: "Workout",
          path: `/overview/workout${reviewProgram && "?review-program=true"}`,
          icon: <Iconify icon="arcticons:home-workouts" />,
        },
        {
          title: "Explanation",
          path: `/overview/explanation`,
          icon: <Iconify icon="arcticons:home-workouts" />,
        },
      ],
    },
    {
      subheader: "Support",
      items: [
        {
          title: "Request Support",
          path: "/support/request-support",
          icon: (
            <Iconify icon="streamline:interface-help-customer-support-1-customer-headset-help-microphone-phone-support" />
          ),
        },
        {
          title: "Bug & Issues Report",
          path: "/support/bug-report",
          icon: <Iconify icon="material-symbols:chat-error-outline-rounded" />,
        },
        {
          title: "Inquires",
          path: "/support/inquires",
          icon: <Iconify icon="line-md:email" />,
        },
      ],
    },
  ];
};

export default NavConfig;
